// ── BACKGROUND SLIDESHOW ──
var bgs = document.querySelectorAll('.bg-slide');
var bgI = 0;
function pwNextBg() {
  if (bgs.length < 2) return;
  bgs[bgI].classList.remove('on');
  bgI = (bgI + 1) % bgs.length;
  bgs[bgI].classList.add('on');
}
if (bgs.length > 0) {
  setInterval(pwNextBg, 6000);
}
window.pwNextBg = pwNextBg;

// ── DETECT MOBILE ──
var isMobile = window.innerWidth < 1024;

// ══════════════════════════════════════
// DESKTOP — FINDER NAVIGATION
// ══════════════════════════════════════
if (!isMobile) {
  var dHist = [], dFut = [];
  var dCur = { panel: 'p-empty', bc: ['gallery'] };

  function dSetPanel(id) {
    document.querySelectorAll('.panel').forEach(function(p) { p.classList.remove('active'); });
    var el = document.getElementById(id);
    if (el) el.classList.add('active');
    dCur.panel = id;
  }

  function dSetBc(parts) {
    var bc = document.getElementById('breadcrumb');
    if (!bc) return;
    bc.innerHTML = parts.map(function(p, i) {
      return i < parts.length - 1
        ? '<span>' + p + '</span><span class="bc-sep"> › </span>'
        : '<span>' + p + '</span>';
    }).join('');
    dCur.bc = parts;
  }

  function dGo(panelId, bc) {
    dHist.push({ panel: dCur.panel, bc: dCur.bc.slice() });
    dFut = [];
    dSetPanel(panelId);
    dSetBc(bc);
  }

  function dSelSection(el, key) {
    dHist.push({ panel: dCur.panel, bc: dCur.bc.slice() });
    dFut = [];
    document.querySelectorAll('.col-1 .finder-row').forEach(function(r) { r.classList.remove('sel'); });
    el.classList.add('sel');

    var col2 = document.getElementById('col-2');
    col2.innerHTML = '<div class="col-hdr"><span>Item</span></div>';

    if (key === 'shop') {
      var items = window.PW_SHOP_ITEMS || [];
      items.forEach(function(item) {
        var r = mkFinderRow('di', item.label, item.img, function() {
          clearCol2Sel();
          r.classList.add('sel');
          dGo('p-product-' + item.handle, ['gallery', 'shop', item.label]);
        });
        col2.appendChild(r);
      });
      dSetPanel('p-empty'); dSetBc(['gallery', 'shop']);

    } else if (key === 'lab') {
      var articles = window.PW_LAB_ITEMS || [];
      articles.forEach(function(art) {
        var r = mkFinderRow('di', art.label, art.img, function() {
          clearCol2Sel();
          r.classList.add('sel');
          dGo('p-lab-' + art.handle, ['gallery', 'lab', art.label]);
        });
        col2.appendChild(r);
      });
      dSetPanel('p-empty'); dSetBc(['gallery', 'lab']);

    } else if (key === 'playlist') {
      var playlists = window.PW_PLAYLIST_ITEMS || [];
      if (playlists.length > 0) {
        playlists.forEach(function(art) {
          var r = mkFinderRow('di', art.label, art.img, function() {
            clearCol2Sel();
            r.classList.add('sel');
            dGo('p-playlist-' + art.handle, ['gallery', 'playlist', art.label]);
          });
          col2.appendChild(r);
        });
        dSetPanel('p-playlist'); dSetBc(['gallery', 'playlist']);
      } else {
        dGo('p-playlist', ['gallery', 'playlist']);
      }
    } else if (key === 'about') {
      dGo('p-about', ['gallery', 'about']);
    }
  }

  function clearCol2Sel() {
    document.querySelectorAll('#col-2 .finder-row').forEach(function(r) { r.classList.remove('sel'); });
  }

  function mkFinderRow(iconClass, label, img, cb) {
    var r = document.createElement('div');
    r.className = 'finder-row';
    var icon = img
      ? '<div class="' + iconClass + ' finder-thumb"><img src="' + img + '" alt=""></div>'
      : '<div class="' + iconClass + '"></div>';
    r.innerHTML = icon
      + '<span class="row-label">' + label + '</span>'
      + '<span class="row-arrow">›</span>';
    r.onclick = cb;
    return r;
  }

  function dBack() {
    if (!dHist.length) return;
    dFut.push({ panel: dCur.panel, bc: dCur.bc.slice() });
    var prev = dHist.pop();
    dSetPanel(prev.panel); dSetBc(prev.bc);
  }

  function dFwd() {
    if (!dFut.length) return;
    dHist.push({ panel: dCur.panel, bc: dCur.bc.slice() });
    var next = dFut.pop();
    dSetPanel(next.panel); dSetBc(next.bc);
  }

  // Drag window
  (function() {
    var win = document.getElementById('app');
    var tbar = document.getElementById('tbar');
    if (!win || !tbar) return;
    win.style.position = 'absolute';
    win.style.top = '50%'; win.style.left = '50%';
    win.style.transform = 'translate(-50%, -50%)';

    var dragging = false, sx = 0, sy = 0, ox = 0, oy = 0, px = 0, py = 0;
    tbar.style.cursor = 'grab';

    tbar.addEventListener('mousedown', function(e) {
      if (e.target.classList.contains('dot')) return;
      dragging = true; sx = e.clientX; sy = e.clientY; ox = px; oy = py;
      win.style.transition = 'none'; tbar.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      px = ox + (e.clientX - sx); py = oy + (e.clientY - sy);
      win.style.transform = 'translate(calc(-50% + ' + px + 'px), calc(-50% + ' + py + 'px))';
    });
    document.addEventListener('mouseup', function() {
      if (!dragging) return;
      dragging = false; tbar.style.cursor = 'grab';
      win.style.transition = '';
    });
  })();

  // Dot buttons
  var isMin = false, isFull = false;
  document.querySelector('.dot.y') && document.querySelector('.dot.y').addEventListener('click', function(e) {
    e.stopPropagation();
    var win = document.getElementById('app');
    var lbl = document.getElementById('dock-label');
    isMin = !isMin;
    if (isMin) {
      win.style.transform = 'translate(-50%, calc(50vh - 22px)) scaleX(0.2) scaleY(0.05)';
      win.style.transition = 'transform .42s cubic-bezier(.4,0,.2,1)';
      setTimeout(function() { if(lbl) lbl.classList.add('show'); }, 380);
    } else {
      win.style.transform = 'translate(-50%, -50%)';
      if(lbl) lbl.classList.remove('show');
    }
  });
  document.querySelector('.dot.g') && document.querySelector('.dot.g').addEventListener('click', function(e) {
    e.stopPropagation();
    var win = document.getElementById('app');
    isFull = !isFull;
    if (isFull) {
      win.style.width = '100vw'; win.style.height = '100vh'; win.style.borderRadius = '0';
    } else {
      win.style.width = ''; win.style.height = ''; win.style.borderRadius = '';
    }
  });
  document.getElementById('dock-label') && document.getElementById('dock-label').addEventListener('click', function() {
    isMin = false;
    var win = document.getElementById('app');
    win.style.transform = 'translate(-50%, -50%)';
    document.getElementById('dock-label').classList.remove('show');
  });
}

// ══════════════════════════════════════
// MOBILE — STACK NAVIGATION
// ══════════════════════════════════════
if (isMobile) {
  var mStack = ['v-home'];
  var mTitles = { 'v-home': 'PLEASEWAIT.GALLERY' };

  function mRender() {
    var cur = mStack[mStack.length - 1];
    var prev = mStack.length > 1 ? mStack[mStack.length - 2] : null;
    var titleEl = document.getElementById('tbar-title');
    var backBtn = document.getElementById('back-btn');
    var backLbl = document.getElementById('back-lbl');
    if (titleEl) titleEl.textContent = (mTitles[cur] || cur).toUpperCase();
    if (backBtn) {
      if (prev) {
        if (backLbl) backLbl.textContent = mTitles[prev] || 'back';
        backBtn.classList.add('show');
      } else {
        backBtn.classList.remove('show');
      }
    }
  }

  function mPush(vid, title) {
    if (!document.getElementById(vid)) return;
    var cur = mStack[mStack.length - 1];
    if (vid === cur) return;
    document.getElementById(cur).classList.add('behind');
    document.getElementById(vid).classList.add('active');
    mTitles[vid] = title;
    mStack.push(vid);
    mRender();
  }

  function mTab(vid, title) {
    document.querySelectorAll('.view').forEach(function(v) {
      if (v.id !== 'v-home') v.classList.remove('active', 'behind');
    });
    document.getElementById('v-home').classList.remove('behind');
    mStack = ['v-home'];
    document.querySelectorAll('.nav-tab').forEach(function(t) { t.classList.remove('on'); });
    var tab = document.getElementById('tab-' + title);
    if (tab) tab.classList.add('on');
    mPush(vid, title);
  }

  function mBack() {
    if (mStack.length <= 1) return;
    var cur = mStack.pop();
    var prev = mStack[mStack.length - 1];
    document.getElementById(cur).classList.remove('active');
    document.getElementById(prev).classList.remove('behind');
    mRender();
  }

  // Retour a l'ecran d'accueil : vide la pile sans empiler de vue
  function mHome() {
    document.querySelectorAll('.view').forEach(function(v) {
      if (v.id !== 'v-home') v.classList.remove('active', 'behind');
    });
    document.getElementById('v-home').classList.remove('behind');
    document.querySelectorAll('.nav-tab').forEach(function(t) { t.classList.remove('on'); });
    mStack = ['v-home'];
    mRender();
  }

  // Un appui sur le fond de l'accueil fait defiler les images
  var homeView = document.getElementById('v-home');
  if (homeView) {
    homeView.addEventListener('click', function(e) {
      if (!e.target.closest('.sb-app')) pwNextBg();
    });
  }

  // Expose globally
  window.mPush = mPush;
  window.mTab = mTab;
  window.mBack = mBack;
  window.mHome = mHome;
}

// Expose desktop functions globally
if (!isMobile) {
  window.dSelSection = dSelSection;
  window.dGo = dGo;
  window.dBack = dBack;
  window.dFwd = dFwd;
}


// ── NATIVE SHOPIFY CART ──
function pwAddToCart(btn) {
  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('loading');
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    btn.classList.remove('loading');
    btn.classList.add('added');
    btn.textContent = '✓ Added';

    // Update cart count
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    pwShowCartNotify(cart.item_count);
    setTimeout(function() {
      btn.classList.remove('added');
      btn.textContent = 'Add To Cart';
    }, 2500);
  })
  .catch(function(err) {
    btn.classList.remove('loading');
    btn.textContent = 'Add To Cart';
    console.error('Cart error:', err);
  });
}

function pwShowCartNotify(count) {
  // Transient notification
  var el = document.getElementById('pw-cart-notify');
  if (!el) {
    el = document.createElement('div');
    el.id = 'pw-cart-notify';
    document.body.appendChild(el);
  }
  el.innerHTML = count + ' item' + (count > 1 ? 's' : '') + ' added';
  el.classList.add('show');
  clearTimeout(el._timeout);
  el._timeout = setTimeout(function() { el.classList.remove('show'); }, 2500);

  // Persistent cart badge
  pwUpdateCartBadge(count);
}

function pwUpdateCartBadge(count) {
  var badge = document.getElementById('pw-cart-badge');
  if (!badge) {
    badge = document.createElement('div');
    badge.id = 'pw-cart-badge';
    badge.innerHTML =
      '<a id="pw-cart-badge-btn" href="/checkout" target="_blank">'
      + 'Checkout <span id="pw-cart-badge-count">' + count + '</span>'
      + '</a>'
      + '<button id="pw-cart-badge-clear" onclick="pwClearCart()">clear cart</button>';
    document.body.appendChild(badge);
  } else {
    var countEl = document.getElementById('pw-cart-badge-count');
    if (countEl) countEl.textContent = count;
  }
  if (count > 0) {
    badge.classList.add('show');
  } else {
    badge.classList.remove('show');
  }
}

function pwClearCart() {
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function() { pwUpdateCartBadge(0); });
}

// Check cart on page load
window.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart.item_count > 0) pwUpdateCartBadge(cart.item_count);
    })
    .catch(function(){});
});
